import {pageInfo, initPage, exportData, initOrderDetail,schOrderAndCustomerSkuList, update, uploadUrl, fileDownload,orderBasicDetailsInfo, cancelSchOrder, orderTracking} from './../api';
import {findAddrsByConsigneeCode, findConsigneesByCustomerCode, findOrderTypesByCustomerCode,selectOrderStatus,selectOrderType,selectOrderCancelReason} from "../../../../api";
const orderMgt = {
  namespaced: true,
  state: {
    total:0,
    pageResp:null,
    initPageObj: null,
    exportObj: null,
    orderDetailObj: null,
    updateObj: null,
    pageDataObj: null,
    OrderTotal: null,
    orderStatusObj: null,
    orderTypeObj: null,
    fileObj: null,
    orderBasicInfoObj :null,
    orderCancleData:null,
    orderCancleReasonObj:null,
    orderTrackIngObj: null
  },
  mutations: {

    PAGE_INFO(state,data){
      state.total = data.total;
      state.pageResp = (data.obj || []).map(item => {
        if ((item.carrierNo != '500729' && (item.consigneeAddrCode != '869219' || item.consigneeAddrCode != '2208240014' || item.consigneeAddrCode != '2208090012'  || item.consigneeAddrCode != '869227'  || item.consigneeAddrCode != '869226'  || item.consigneeAddrCode != '2205270049'))){
          return {
            ...item,
            btns: [{ disabled: item.isCanEdit !== 'Y' }, { disabled: item.isCanCancel == 'N' }, false ],
            showColor: item.schOrderStatusName == '已取消'
          }
        } else {
          return {
            ...item,
            btns: [{ disabled: item.isCanEdit !== 'Y' }, { disabled: item.isCanCancel == 'N' }, true ],
            showColor: item.schOrderStatusName == '已取消'
          }
        }
      });
    },
    INIT_PAGE(state,data) {
      state.initPageObj = data.obj || {};
    },
    EXPORT_DATA(state, data) {
      state.exportObj = data;
    },
    INIT_ORDER_DETAIL(state, data) {
      state.orderDetailObj = data.obj;
    },
    UPDATE_DATA(state, data) {
      state.updateObj = data;
    },
    SEARCH_ORDER_DATA(state, data) {
      state.OrderTotal = data.total;
      state.pageDataObj = data.obj || [];
    },
    FIND_CONSIGNEES_BY_CUSTOMERCODE_DATA(state,data){
      state.consigneesObj = data.obj || {};
    },
    FIND_ADDRS_BY_CONSIGNEECODE_DATA(state,data){
      state.consigneecAddrsObj = data.obj || {};
    },
    FIND_ORDERTYPES_BY_CUSTOMERCODE_DATA(state,data){
      state.ordertypesObj = data.obj || {};
    },
    UPLOAD_URL_DATA(state, data){
      state.uploadUrlObj = data || '';
    },
    ORDER_STATUS(state,data){
      state.orderStatusObj = data.obj || {};
    },
    ORDER_TYPE(state,data){
      state.orderTypeObj = data.obj || {};
    },
    FILE_DATA(state, data) {
      state.fileObj = data;
    },
    ORDERBASIC_DETAILS_INFO(state, data) {
      state.orderBasicInfoObj = data.obj || {};
    },
    CANCLE_ORDER_DATA(state, data) {
      state.orderCancleData = data;
    },
    ORDER_CANCEL_REASON(state, data) {
      state.orderCancleReasonObj = data.obj || {};
    },
    ORDER_TRACK_DATA(state, data) {
      state.orderTrackIngObj = data.obj || {};
    },
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj){
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    //初始化页面事件
    async initPage({commit}, obj){
      let resp = await initPage(obj);
      commit('INIT_PAGE', resp);
    },
    //导出数据
    async exportData({ commit }, obj) {
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },
    //编辑初始化
    async initOrderDetail({commit}, obj){
      let resp = await initOrderDetail(obj);
      commit('INIT_ORDER_DETAIL', resp);
    },
    //产品分页
    async schOrderAndCustomerSkuList({commit}, obj){
      let resp = await schOrderAndCustomerSkuList(obj);
      commit('SEARCH_ORDER_DATA', resp);
    },
    //修改
    async update({commit}, obj){
      let resp = await update(obj);
      commit('UPDATE_DATA', resp);
    },

    async findConsigneesByCustomerCode({commit}, obj){
      let resp = await findConsigneesByCustomerCode(obj);
      commit('FIND_CONSIGNEES_BY_CUSTOMERCODE_DATA', resp);
    },
    async findAddrsByConsigneeCode({commit}, obj){
      let resp = await findAddrsByConsigneeCode(obj);
      commit('FIND_ADDRS_BY_CONSIGNEECODE_DATA', resp);
    },
    async findOrderTypesByCustomerCode({commit}, obj){
      let resp = await findOrderTypesByCustomerCode(obj);
      commit('FIND_ORDERTYPES_BY_CUSTOMERCODE_DATA', resp);
    },
    //文件上传路径
    async uploadUrl({ commit }, obj) {
      let resp = await uploadUrl(obj);
      commit('UPLOAD_URL_DATA', resp);
    },
    async selectOrderStatus({commit}, obj){
      let resp = await selectOrderStatus(obj);
      commit('ORDER_STATUS', resp);
    },
    async selectOrderType({commit}, obj){
      let resp = await selectOrderType(obj);
      commit('ORDER_TYPE', resp);
    },
    //附件下载
    async fileDownload({ commit }, obj) {
      let resp = await fileDownload(obj);
      commit('FILE_DATA', resp);
    },
    //订单详情
    async orderBasicDetailsInfo({ commit }, obj) {
      let resp = await orderBasicDetailsInfo(obj);
      commit('ORDERBASIC_DETAILS_INFO', resp);
    },
    //订单取消
    async cancelSchOrder({ commit }, obj) {
      let resp = await cancelSchOrder(obj);
      commit('CANCLE_ORDER_DATA', resp);
    },
    //订单取消
    async selectOrderCancelReason({ commit }, obj) {
      let resp = await selectOrderCancelReason(obj);
      commit('ORDER_CANCEL_REASON', resp);
    },
    //查询gps接口轨迹信息
    async orderTracking({ commit }, obj) {
      let resp = await orderTracking(obj);
      commit('ORDER_TRACK_DATA', resp);
    },
  }
}
export default orderMgt



// WEBPACK FOOTER //
// ./src/page/order/orderMgt/store/orderMgt.store.js